import Axios from "axios";
import { useContext, useState } from "react";

import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";

import DashboardContext from "../../../Context";

export default function ModalDeleteAddress({ show, handelClose, iditemDelete, handelReload }) {

    const { authentication, urldashboard } = useContext(DashboardContext);

    const [LodingForm, setLodingForm] = useState(false)

    const [dataDelete, setDataDelete] = useState({})

    const handelDelete = async () => {
        setLodingForm(true)
        try {
            const res = await Axios.delete(`${urldashboard}/address/delete/${iditemDelete}`, {
                headers: {
                    "Authorization": authentication,
                    "content-type": "application/json; charset=utf-8"
                }
            })

            const data = await res.data

            setDataDelete(data)
            setLodingForm(false)
            handelClose()
            handelReload()
            toast.success(data.message, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

        } catch (error) {
            if (error.message === 'Network Error') {
                setDataDelete({ status: 500, message: 'اینترنت قطع است لطفا وضعیت اینترنت را بررسی کنید:(' })
                setLodingForm(false)
            }
            else {
                setDataDelete(error.response.data)
                setLodingForm(false)
            }
        }
    }



    return (
        <Modal show={show} onHide={handelClose}>
            <Modal.Header >
                <Modal.Title >حذف ادرس انتخابی</Modal.Title>
            </Modal.Header>
            <Modal.Body  >
                <i className="mdi mdi-alert-circle-outline"></i>
                {
                    LodingForm ?
                        "درحال حذف منتظر باشید..."
                        :
                        dataDelete.hasOwnProperty("status") ?
                            dataDelete.message
                            :
                            "آیا از حذف  ادرس مطمئن هستید؟"
                }
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" disabled={LodingForm} onClick={handelClose}>
                    خیر
  </Button>
                <Button variant="success" disabled={LodingForm} onClick={handelDelete}>
                    {
                        LodingForm ?
                            <i className="fa fa-spinner fa-pulse fa-fw"></i>

                            : "بله"
                    }
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
